export default "__VITE_ASSET__822e5193__"